// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
//import './lib/weui.min.css'
// import './lib/weui.min.js'
// import './lib/jquery-weui.min.css'
import { Base64 } from 'js-base64'
import './lib/flexible.js'
import './lib/drag-loading.js'
import './assets/iconfont/iconfont'

import Vue from 'vue'
import App from './App'
import router from './router'
import util from './lib/util'
import '../node_modules/vue-awesome-swiper/node_modules/swiper/dist/css/swiper.css'
import VueAwesomeSwiper from 'vue-awesome-swiper'

// import fastclick from 'fastclick'
// fastclick.attach(document.body)

import './lib/BeAlert-master/BeAlert.js'
import './lib/BeAlert-master/BeAlert.css'

import './lib/jquery-weui.min.css'
import './lib/weui.min.js'
import './lib/weui.min.css'
import './lib/jquery-weui.min'
import './lib/city-picker.min'

import './assets/vue-touch.js'
import store from './store'
import Mint from 'mint-ui'
import "babel-polyfill"

Vue.use(Mint)
Vue.use(util)
Vue.use(VueAwesomeSwiper)



// 注册一个全局自定义指令 v-focus
Vue.directive('focus', {
  // 当绑定元素插入到 DOM 中。
  inserted: function (el) {
    // 聚焦元素
    el.focus()
  }
})

Vue.config.productionTip = false

var data = { config: { currentPeriod: {}, nextPeriod: {}, periodList: [], gradeList: [], subjectList: [] } }
///ios兼容提示
try {
  window.localStorage.setItem('testSafari', 'true');
} catch (err) {
  alert("本地储存写入错误，若为safari浏览器请关闭无痕浏览。");
}


let referrer = util.getQueryString('referrer')
if (referrer) {
  sessionStorage.setItem('referrer', Base64.decode(referrer))
}

Vue.mixin({
  methods:{
     hasLogin(){
       return localStorage.getItem("accessToken") ? true : false
     },
     checkLogin(){
       if(!this.hasLogin()){
         this.$router.push({ path : '/login' , query : {  backUrl: document.location.href  }})
         throw new Error('No login')
       }
     }
  }
})

new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App },
  data: data,
  store,
})









// WEBPACK FOOTER //
// ./src/main.js